import React, { useEffect, useRef, useState } from "react";
import '../../../assets/css/Attendance.css'
import exporticon from '../../../assets/icons/export-data.svg';
import SpinnerLoader from '../../../Utils/Spinner';
import Notifier from "../../../Utils/notify";
import { getBlob, getData } from "../../../API/GlobalApi";
const AttendanceReport = ({ selectedEmployee, zoomedOut, loadingSummary, setLoadingSummary, summary, setSummary, reportMonth, reportYear, setSelectedEmployee, selectedEmployeeId }) => {

    const today = new Date();

    const [month, setMonth] = useState(reportMonth ?? new Date().getMonth());
    const [year, setYear] = useState(reportYear ?? new Date().getFullYear());




    useEffect(() => {

        if (selectedEmployee?.length === 0 || reportMonth == null || reportYear == null) return;
        const fetchMonthlySummary = async () => {
            setLoadingSummary(true);
            try {
                if (!selectedEmployeeId) return;
                const url = `staff/attendance-summary/?employee_id=${selectedEmployeeId}&month=${month + 1}&year=${year}`;
                const res = await getData(url);
                setSelectedEmployee(res?.data.employees || []);
                setSummary({
                    month: res.data.month,
                    year: res.data.year,
                    total: res.data.total_employees
                });
            } catch (err) {
                console.error("Failed to fetch summary:", err);
                Notifier.error("Failed to load attendance summary");
            } finally {
                setLoadingSummary(false);
            }
        };

        fetchMonthlySummary();
    }, [month, year]);


    useEffect(() => {
        if (reportMonth != null) setMonth(reportMonth);
        if (reportYear != null) setYear(reportYear);
    }, [reportMonth, reportYear]);


    const leaveColors = {
        CL: "#4CAF50", LWP: "#F44336", CPL: "#2196F3", Sick: "#FF9800",
        WFH: "#9C27B0", PL: "#00BCD4", ML: "#E91E63", EL: "#FFC107",
        HPL: "#795548", SL: "#009688", VL: "#3F51B5", OL: "#FF5722",
        HL: "#607D8B", CompOff: "#8BC34A", Holiday: "#CDDC39",
    };

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const daysInMonth = (y, m) => new Date(y, m + 1, 0).getDate();


    const firstDate = new Date(year, month, 1);
    const totalDays = daysInMonth(year, month);

    const allDates = Array.from({ length: totalDays }, (_, i) => {
        return new Date(year, month, i + 1);
    });


    const weekdayInitial = (dateObj) => ["S", "M", "T", "W", "T", "F", "S"][dateObj.getDay()];

    const goPrevMonth = () => {
        let newMonth = month - 1, newYear = year;
        if (newMonth < 0) { newMonth = 11; newYear -= 1; }
        setMonth(newMonth);
        setYear(newYear);

    };

    const goNextMonth = () => {
        let newMonth = month + 1, newYear = year;
        if (newMonth > 11) { newMonth = 0; newYear += 1; }
        setMonth(newMonth);
        setYear(newYear);

    };

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 11 }, (_, i) => currentYear - 5 + i);

    const monthGroups = [];
    let lastMonth = allDates[0].getMonth();
    let count = 0;
    allDates.forEach((d, idx) => {
        if (d.getMonth() === lastMonth) count++;
        else { monthGroups.push({ month: lastMonth, span: count }); lastMonth = d.getMonth(); count = 1; }
        if (idx === allDates.length - 1) monthGroups.push({ month: lastMonth, span: count });
    });

    // helper to calculate leave summary
    const calcLeaveSummary = (leavesObj) => {
        const total = Object.keys(leavesObj).length;
        const deducted = Object.values(leavesObj).filter(l => ["LWP", "ML", "CL"].includes(l)).length;
        const left = total - deducted;
        return { total, deducted, left };
    };

    const stickyColWidth = window.innerWidth < 768 ? 80 : 120;
    const leaveColWidth = window.innerWidth < 768 ? 28 : 40;

    const leftOffsets = [
        0,                                  // Name column
        stickyColWidth,                    // Total Leave
        stickyColWidth + leaveColWidth,    // Deducted
        stickyColWidth + 2 * leaveColWidth // Leave Left
    ];



    const [search, setSearch] = useState("");

    const filteredEmployees = selectedEmployee?.filter(emp => {
        if (!search.trim()) return true;

        const query = search.toLowerCase();

        return (
            emp.employee_name?.toLowerCase().includes(query) ||
            emp.unique_code?.toLowerCase().includes(query)
        );
    });


    const handleExportExcel = async () => {

        try {
            const urlWithParams = `staff/attendance-summary-export/?month=${month + 1}&year=${year}`;
            // const urlWithParams = "staff/attendance-summary-export/"
            const blob = await getBlob(urlWithParams);

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Attendance_Summary_Report.xlsx';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } catch (error) {
            Notifier.error('❌ Excel export failed');
        }
    };

    return (
        <div style={styles.container}>
            {loadingSummary ? <SpinnerLoader /> : (
                <div style={styles.mainLayout} className="mainLayout">
                    <div style={styles.yearSelector} className="yearSelector">
                        {years.map((yr) => (
                            <div key={yr} style={{ ...styles.yearItem, ...(yr === year ? styles.yearItemActive : {}) }} onClick={() => setYear(yr)}>{yr}</div>
                        ))}
                    </div>

                    <div style={styles.contentWrapper} className="attendanceReportWrapper">
                        <div className="row align-items-center mb-3">
                            {/* Left half: Employee summary + month navigation */}
                            <div className="col-md-6 d-flex flex-wrap align-items-center gap-5">
                                <div style={styles.summaryItem}>👥 Employees <strong>{summary?.total}</strong></div>
                                <div className="d-flex align-items-center gap-2">
                                    <button className="btn btn-light" onClick={goPrevMonth} style={styles.arrowBtn}>⬅</button>
                                    <span style={styles.currentMonthLabel} className="calenderMonth">{monthNames[month]} {year}</span>
                                    <button className="btn btn-light" onClick={goNextMonth} style={styles.arrowBtn}>➡</button>
                                </div>
                            </div>

                            {/* Right half: Search + Export */}
                            <div className="col-md-6 d-flex flex-wrap justify-content-center align-items-center gap-2">
                                <input
                                    type="text"
                                    placeholder="Search Employee / ID"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                    style={{ ...styles.searchInput, }}
                                    className="searchInputFocusAttendance"
                                    autoFocus
                                />
                                <button
                                    className="filter-btn d-flex align-items-center justify-content-center"
                                    style={{ background: 'white', border: '1px solid #7F56DA', height: '43px', padding: '0 10px' }}
                                    onClick={handleExportExcel} >
                                    <img src={exporticon} alt='Export icon' style={{ width: '20px', height: '20px' }} />
                                </button>
                            </div>
                        </div>

                        <div style={styles.tableContainer} className="atendanceReportContainer">
                            <div style={styles.tableWrapper} className="tableWrapper">
                                <table style={styles.table}>
                                    <thead>
                                        {/* First Row — Sticky Columns + Month Names */}
                                        <tr>
                                            {/* Name Column */}
                                            <th
                                                rowSpan={2}
                                                style={{
                                                    ...styles.stickyCol,
                                                    width: stickyColWidth,
                                                    minWidth: stickyColWidth,
                                                    maxWidth: stickyColWidth,
                                                    left: 0,
                                                    top: 0,
                                                    zIndex: 180, // higher than other sticky columns
                                                    backgroundColor: "#f7f7f7",
                                                    // boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                Name
                                            </th>


                                            {/* Total Leave Column */}
                                            <th
                                                rowSpan={2}
                                                style={{
                                                    ...styles.stickyCol,
                                                    width: leaveColWidth,
                                                    minWidth: leaveColWidth,
                                                    maxWidth: leaveColWidth,
                                                    left: stickyColWidth,
                                                    top: 0,
                                                    zIndex: 103,
                                                    backgroundColor: "#f7f7f7",
                                                    writingMode: "vertical-rl",
                                                    transform: "rotate(180deg)",
                                                    WebkitTransform: "rotate(180deg)",
                                                    textAlign: "center",
                                                    padding: "4px 2px",
                                                    fontSize: "10px",
                                                    //  fontWeight:'bold',
                                                    // boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                Total Leave
                                            </th>

                                            {/* Deducted Column */}
                                            <th
                                                rowSpan={2}
                                                style={{
                                                    ...styles.stickyCol,
                                                    width: leaveColWidth,
                                                    minWidth: leaveColWidth,
                                                    maxWidth: leaveColWidth,
                                                    left: stickyColWidth + leaveColWidth,
                                                    top: 0,
                                                    zIndex: 103,
                                                    backgroundColor: "#f7f7f7",
                                                    writingMode: "vertical-rl",
                                                    transform: "rotate(180deg)",
                                                    WebkitTransform: "rotate(180deg)",
                                                    textAlign: "center",
                                                    padding: "4px 2px",
                                                    fontSize: "10px",
                                                    // boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                Deducted
                                            </th>

                                            {/* Leave Left Column */}
                                            <th
                                                rowSpan={2}
                                                style={{
                                                    ...styles.stickyCol,
                                                    width: leaveColWidth,
                                                    minWidth: leaveColWidth,
                                                    maxWidth: leaveColWidth,
                                                    left: stickyColWidth + 2 * leaveColWidth,
                                                    top: 0,
                                                    zIndex: 103,
                                                    backgroundColor: "#f7f7f7",
                                                    writingMode: "vertical-rl",

                                                    transform: "rotate(180deg)",
                                                    WebkitTransform: "rotate(180deg)",

                                                    textAlign: "center",
                                                    padding: "4px 2px",
                                                    fontSize: "10px",
                                                    // boxShadow: "2px 0 5px rgba(0,0,0,0.1)",
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                Leave Left
                                            </th>

                                            {/* Month Names */}
                                            {monthGroups.map((grp, idx) => (
                                                <th
                                                    key={idx}
                                                    colSpan={grp.span}
                                                    style={{
                                                        ...styles.monthNameCol,
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 101,
                                                        backgroundColor: "#7F56DA",
                                                        color: "#fff",
                                                        textAlign: "center",
                                                        borderLeft: "1px solid #ccc",
                                                        borderBottom: "1px solid #ccc",
                                                    }}
                                                >
                                                    {monthNames[grp.month]}
                                                </th>
                                            ))}
                                        </tr>

                                        {/* Second Row — Dates */}
                                        <tr>
                                            {allDates.map((dateObj, idx) => {


                                                const isSunday = dateObj.getDay() === 0;
                                                return (
                                                    <th
                                                        key={idx}
                                                        style={{
                                                            ...styles.dayCol,
                                                            position: "sticky",
                                                            top: "30px", // height of month name row
                                                            zIndex: 100,
                                                            backgroundColor: isSunday ? "#f0f0f0" : "#fff",
                                                            color: isSunday ? "#999" : "#000",
                                                            border: "1px solid #ccc",
                                                            padding: "4px",
                                                        }}
                                                    >
                                                        <div style={styles.dayHeader}>{dateObj.getDate()}</div>
                                                        <div style={styles.weekday}>{weekdayInitial(dateObj)}</div>
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredEmployees?.length === 0 ? (
                                            <tr>
                                                <td
                                                    colSpan={allDates.length + 4}
                                                    style={{
                                                        textAlign: "center",
                                                        padding: "20px",
                                                        color: "#888",
                                                        fontSize: "14px",
                                                    }}
                                                >
                                                    No employees found
                                                </td>
                                            </tr>
                                        ) : (filteredEmployees?.map((emp) => {
                                            // const summary = calcLeaveSummary(emp?.attendance);

                                            const isSelected = emp?.is_selected === true;


                                            return (
                                                <tr
                                                    key={emp.id}
                                                    style={{
                                                        fontWeight: isSelected ? "bold" : "normal", // optional bold text
                                                        backgroundColor: isSelected ? "#f2edff" : "inherit", // 🔴 light red background
                                                        border: isSelected ? "2px solid #7F56DA" : "none",
                                                        backgroundColor: isSelected ? "#f2edff" : "inherit", // 🔴 light red background
                                                    }}
                                                >
                                                    <td
                                                        style={{
                                                            ...styles.stickyCol,
                                                            width: leaveColWidth,
                                                            left: leftOffsets[0], // Name column
                                                            textAlign: "left", // optional
                                                            backgroundColor: isSelected ? "#f2edff" : "#f7f7f7",
                                                        }}
                                                    >
                                                        <div style={{
                                                            display: "flex", flexDirection: "column", lineHeight: "1.2",
                                                            color: isSelected ? "#7F56DA" : "#666"
                                                        }}>
                                                            <span style={{ fontWeight: "" }}>{emp.employee_name}</span>
                                                            <span style={{ fontSize: "12px", }}>{emp?.unique_code}</span>
                                                        </div>
                                                    </td>

                                                    <td
                                                        style={{
                                                            ...styles.stickyCol,
                                                            width: leaveColWidth,
                                                            left: leftOffsets[1], // Total Leave
                                                            zIndex: 30,
                                                            backgroundColor: isSelected ? "#f2edff" : "#f7f7f7",
                                                        }}
                                                    >
                                                        {/* {emp?.absent_days} */}
                                                    </td>

                                                    <td
                                                        style={{
                                                            ...styles.stickyCol,
                                                            width: leaveColWidth,
                                                            left: leftOffsets[2], // Deducted
                                                            zIndex: 30,
                                                            backgroundColor: isSelected ? "#f2edff" : "#f7f7f7",
                                                        }}
                                                    >
                                                        {/* {summary.deducted} */}
                                                    </td>

                                                    <td
                                                        style={{
                                                            ...styles.stickyCol,
                                                            width: leaveColWidth,
                                                            left: leftOffsets[3], // Leave Left

                                                            zIndex: 30,
                                                            backgroundColor: isSelected ? "#f2edff" : "#f7f7f7",
                                                        }}
                                                    >
                                                        {/* {summary.left} */}
                                                    </td>
                                                    {allDates.map((dateObj, idx) => {
                                                        const today = new Date();
                                                        today.setHours(0, 0, 0, 0);
                                                        //  const key = dateObj.toISOString().split("T")[0]; 
                                                        const key = `${dateObj.getFullYear()}-${String(dateObj.getMonth() + 1).padStart(2, "0")}-${String(dateObj.getDate()).padStart(2, "0")}`;

                                                        const attendanceMap = {};
                                                        emp.attendance?.forEach(a => {
                                                            attendanceMap[a.date] = a;
                                                        });

                                                        const att = attendanceMap[key];
                                                        const isSunday = dateObj.getDay() === 0;
                                                        // Blank for future dates
                                                        const isFuture = dateObj > today;
                                                        let bgColor;
                                                        if (isSelected) bgColor = "#f2edff";
                                                        else if (isSunday) bgColor = "#f0f0f0";
                                                        else bgColor = "#fff";
                                                        let text = "";
                                                        let color = "#000";

                                                        if (!isFuture && att) {
                                                            if (att.is_present) {
                                                                text = "P";
                                                                color = "green";
                                                            } else {
                                                                text = "A";
                                                                color = "red";
                                                            }
                                                        }
                                                        return (
                                                            <td
                                                                key={idx}
                                                                style={{
                                                                    ...styles.dayCol,
                                                                    backgroundColor: bgColor,
                                                                    textAlign: "center",
                                                                    fontWeight: "bold",
                                                                    color: color,
                                                                    fontSize: '12px'
                                                                }}
                                                            >
                                                                {isFuture ? "" : text}
                                                            </td>
                                                        );
                                                    })}

                                                </tr>
                                            );
                                        })
                                        )

                                        }
                                    </tbody>


                                </table>

                            </div>
                        </div>
                    </div>
                </div>)}
        </div>
    );
};

export default AttendanceReport;

const styles = {
    container: { fontFamily: "Arial, sans-serif", padding: "20px", width: "100%", height: "100vh", display: "flex", flexDirection: "column" },
    header: { display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" },
    title: { margin: 0 },
    filters: { display: "flex", gap: "10px", flexWrap: "wrap", marginTop: "15px" },
    searchInput: { flex: 1, minWidth: "120px", padding: "8px", border: "1px solid #ccc", borderRadius: "4px", backgroundColor: '#F9F9F9', fontSize: '14px' },
    filterBtn: { padding: "8px 12px", backgroundColor: "#eee", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer" },
    applyBtn: { padding: "8px 12px", backgroundColor: "#1976d2", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" },
    mainLayout: { display: "flex", gap: "10px", marginTop: "15px", flexWrap: "wrap", flex: 1, overflow: "hidden" },
    yearSelector: { display: "flex", flexDirection: "column", gap: "10px", minWidth: "120px", paddingTop: "10px", borderRight: "1px solid #ccc", flexShrink: 0, maxHeight: "100%", overflowY: "auto" },
    yearItem: { padding: "6px 12px", borderRadius: "6px", textAlign: "center", border: "1px solid #f0f0f0", cursor: "pointer", whiteSpace: "nowrap", fontSize: '15px', fontWeight: '500' },
    yearItemActive: { backgroundColor: "#7F56DA", color: "#fff", fontWeight: "bold" },
    contentWrapper: { flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" },
    summary: { display: "flex", gap: "20px", marginBottom: "15px", flexWrap: "wrap" },
    summaryItem: { backgroundColor: "#f9f9f9", padding: "6px 10px", borderRadius: "4px" },
    monthNav: { display: "flex", justifyContent: "end", alignItems: "center", gap: "10px", marginBottom: "10px", flexWrap: "wrap" },
    arrowBtn: { padding: "6px 10px", color: "#7F56DA", border: "none", borderRadius: "4px", cursor: "pointer" },
    currentMonthLabel: {
        fontWeight: "bold", fontSize: "16px", color: '#7F56DA', minWidth: "120px", // ✅ ensures stable width
        textAlign: "center",
    },

    tableContainer: { width: "100%", overflowX: "auto", overflowY: "auto", maxHeight: "70vh", height: '100%', border: "1px solid #ddd", borderRadius: "6px", flex: 1, },
    tableWrapper: { minWidth: "800px", },
    table: {
        borderCollapse: "separate", width: "100%",
        borderSpacing: 0
    },
    stickyCol: {
        border: "1px solid #ccc", padding: "6px", textAlign: "left", minWidth: "35px", backgroundColor: "#f7f7f7", position: "sticky", zIndex: 10, whiteSpace: "nowrap", fontSize: '14px', width: "auto", flexShrink: 0,
        boxSizing: "border-box",
    },

    monthNameCol: { border: "1px solid #ccc", padding: "8px 4px", textAlign: "center", backgroundColor: "#1976d2", color: "#fff", fontWeight: "500", fontSize: "14px" },
    dayCol: { border: "1px solid #ccc", padding: "2px", textAlign: "center", minWidth: "35px", backgroundColor: "#fff" },
    dayHeader: { fontSize: "10px", fontWeight: "bold", lineHeight: "12px" },
    weekday: { fontSize: "9px", color: "#666", lineHeight: "10px" },
    badge: { display: "inline-block", color: "#fff", padding: "1px 3px", borderRadius: "3px", fontSize: "8px", fontWeight: "bold" },

};
